import { getWorkflowIconsFromFeatures } from 'marketplace-ui-common/workflow-templates/getWorkflowIconsFromFeatures';
function toWorkflowActionFeature(feature) {
  var _feature$metadata, _feature$metadata2, _feature$metadata3, _feature$metadata4;
  if (feature.type !== 'WORKFLOW_ACTION') {
    return null;
  }
  return {
    name: feature.name,
    orderIndex: (_feature$metadata = feature.metadata) === null || _feature$metadata === void 0 ? void 0 : _feature$metadata.orderIndex,
    iconUrl: (_feature$metadata2 = feature.metadata) === null || _feature$metadata2 === void 0 ? void 0 : _feature$metadata2.iconUrl,
    iconActionType: (_feature$metadata3 = feature.metadata) === null || _feature$metadata3 === void 0 ? void 0 : _feature$metadata3.iconActionType,
    actionTypeId: (_feature$metadata4 = feature.metadata) === null || _feature$metadata4 === void 0 ? void 0 : _feature$metadata4.actionTypeId
  };
}
export function getWorkflowIconsFromProductFeatures(productFeatures = []) {
  const features = productFeatures.map(toWorkflowActionFeature).filter(feature => feature !== null);
  return getWorkflowIconsFromFeatures(features);
}